import React, { useEffect, useState } from 'react'
import { Modal, Skeleton } from '@mui/material'
import { highlightStyles as styles } from "./HighlightViewGameModal.tailwind.js"
import earn_pointsVideo from '../../../../assets/videos/earn_points_1.mov'
import { Close } from '@mui/icons-material'

const HighlightViewGameModal = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);


  //THIS USEFFECT IS TO PREVENT RESIZE OBSERVER FROM CAUSING ERRORS
  useEffect(() => {
    const observer = new ResizeObserver(() => {});
    observer.observe(document.body);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement;
      setIsFullscreen(!!fullscreenElement);
    };
  
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  
   return (
        <Modal open={isOpen} disableAutoFocus disableEnforceFocus onClose={onClose}>
            <div className={styles.container}>
                <button className='absolute right-2 top-1 z-10' onClick={onClose}>
                    <Close fontSize='14' />
                </button>
                <div className='w-full h-full'>
                    {isLoading && (
                        <Skeleton
                            variant="rounded"
                            width="100%"
                            height="100%"
                            animation="wave"
                            sx={{ bgcolor: 'grey.700' }}
                        />
                    )}
                    <video
                        controls
                        alt="Full Screen Preview"
                        className={`${isFullscreen ? 'object-contain' : 'object-fill'}`}
                        onLoadedData={() => setIsLoading(false)}
                        type="video/mp4" 
                    >
                        <source src={earn_pointsVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </Modal>
    )
}

export default HighlightViewGameModal